const selectors = {
  form: '[data-purchase-form]',
  variantSelect: '[data-purchase-form] select',
  countMetafield: '[data-pdp-variant-count-id]',
};

const handleVariantChange = (target) => {
  const select = target;
  const form = target.closest(selectors.form);
  if (!select || !form) return;

  const variantID = select.value;
  const allCountMetafields = form.querySelectorAll(selectors.countMetafield);
  const countMetafield = form.querySelector(`.count-id-${variantID}`);
  
  Array.from(allCountMetafields).forEach((metafield) => {
    metafield.classList.add('hide');
  });
  
  countMetafield.classList.remove('hide');
};

const init = () => {
  window.handleVariantChange = handleVariantChange;
}

init();
